import { INavLink } from "core-integration/src/hooks/types";
import { RootState } from "core-integration/src/store";
import { getEntry } from "core-integration/src/store/entries/reducers";
import {
  getCurrentEvent,
  getNextEvent,
} from "core-integration/src/store/events/reducers";
import { getServerError } from "core-integration/src/store/global/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getIsWebView } from "../../utils/webView";
import ListItem from "./ListItem";
import { NavContainer, StyledNav, StyledUL } from "./styles";

const NavigationLinks = ({ links }: { links: INavLink[] }) => {
  return (
    <StyledNav role="navigation" className="ism-nav">
      <NavContainer>
        <StyledUL>
          {links.map((link) => (
            <ListItem {...link} key={link.text} />
          ))}
        </StyledUL>
      </NavContainer>
    </StyledNav>
  );
};

const Navigation = () => {
  const logoutUrl = "/player/logout/";
  const { t } = useTranslation();
  const player = useSelector(getPlayerData);
  const currentEvent = useSelector(getCurrentEvent);
  const nextEvent = useSelector(getNextEvent);
  const serverError = useSelector(getServerError);
  const entry = useSelector((state: RootState) =>
    player && player.entry ? getEntry(state, player.entry) : null,
  );

  let links: INavLink[] = [];
  const useRouter = !serverError;

  if (player && player.entry) {
    // Logged in with entry
    links = [
      {
        useRouter,
        href: "/",
        text: currentEvent
          ? t("navigation.status", "Status")
          : t("navigation.home", "Home"),
      },
    ];
    if (nextEvent) {
      links.push({
        useRouter,
        href: "/my-team",
        text: t("navigation.myTeam", "My Team"),
      });
    }
    // If the entry has started ...
    if (currentEvent && entry && entry.started_event <= currentEvent.id) {
      links.push({
        useRouter,
        href: `/entry/${player.entry}/event/${currentEvent.id}`,
        text: t("navigation.points", "Points"),
      });
    }
    links.push(
      {
        useRouter,
        href: "/transfers",
        text: t("navigation.transfers", "Transfers"),
      },
      {
        useRouter,
        href: "/leagues",
        text: t("navigation.leagues", "Leagues"),
      },
      {
        useRouter,
        href: "/fixtures",
        text: t("navigation.fixtures", "Fixtures"),
      },
      {
        useRouter,
        href: "/statistics",
        text: t("navigation.statistics", "Statistics"),
      },
    );
    if (!getIsWebView()) {
      links.push({
        useRouter,
        href: "/prizes",
        text: t("navigation.prizes", "Prizes"),
      });
    }
    links.push({
      useRouter,
      href: "/help",
      text: t("navigation.help", "Help"),
    });
    if (!getIsWebView() && logoutUrl) {
      links.push({
        useRouter: false,
        href: logoutUrl,
        text: t("navigation.signOut", "Sign out"),
      });
    }
  } else if (player) {
    // Logged in, no entry
    links = [
      { useRouter, href: "/", text: t("navigation.home", "Home") },
      {
        useRouter,
        href: "/squad-selection",
        text: t("navigation.squadSelection", "Squad Selection"),
      },
      { useRouter, href: "/help", text: t("navigation.help", "Help") },
    ];
    if (!getIsWebView() && logoutUrl) {
      links.push({
        useRouter: false,
        href: logoutUrl,
        text: t("navigation.signOut", "Sign out"),
      });
    }
  } else {
    // Logged Out
    links = [{ useRouter, href: "/", text: t("navigation.home", "Home") }];
    if (!getIsWebView()) {
      links.push({
        useRouter,
        href: "/prizes",
        text: t("navigation.prizes", "Prizes"),
      });
    }
    links.push(
      { useRouter, href: "/help", text: t("navigation.help", "Help") },
      {
        useRouter,
        href: "/statistics",
        text: t("navigation.statistics", "Statistics"),
      },
    );
  }
  return <NavigationLinks links={links} />;
};

export { Navigation as NavigationTest };

export default Navigation;
